import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'ccs-ngl-prmrybtn',
  templateUrl: './ccs-ngl-prmrybtn.component.html',
  styleUrls: ['./ccs-ngl-prmrybtn.component.scss']
})
export class CcsNglPrmrybtnComponent implements OnInit {
  @Input() class = '';
  @Input() bdata = '';
  @Input() iclass = '';
  @Input() showplus:boolean = false;
  @Output() action = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

}
